<template>
	<div class="tabulation">
		<el-card class="chart-card">
			<!-- 搜索框 -->
			<div>
				<div class="grabble">
					<div class="statistics">
						统计：{{filterTableData.length}}条
					</div>
				</div>
					<div class="grabble1">
					<div class="statistics">
					</div>
					<div>
						<el-button style="margin-left: 10px" type="primary" size="default" @click="handleAdd">
							<el-icon class="cancelgu">
								<Plus />
							</el-icon>添加</el-button>
					
					</div>
				</div>
			</div>
			<el-table ref="tableRef" :data="filterTableData" style="width: 100%" :fit="true" row-key="unionId" border
				scrollbar-always-on :header-cell-style="{ background: '#F5F7FA' }" :empty-text="texts">
				<!-- 会员姓名 -->
				<el-table-column align="center" label="工会ID" prop="unionId" min-width="120"/>
				<!-- 工会名称 -->
				<el-table-column label="工会名称" prop="unionName" align="center" min-width="250" :show-overflow-tooltip='true'>
				</el-table-column>
				<!-- 工会编码 -->
				<el-table-column label="工会编码" prop="unionCode" align="center" min-width="200"
					:show-overflow-tooltip='true'>
				</el-table-column>
				<!-- 达标步数 -->
				<el-table-column label="达标步数" prop="standardSteps" align="center" min-width="150"
					:show-overflow-tooltip='true'>
				</el-table-column>
				<!-- 达标天数 -->
				<el-table-column label="达标天数" prop="standardDays" align="center" min-width="150"
					:show-overflow-tooltip='true'>
				</el-table-column>
				<!-- 统计方式 -->
				<el-table-column label="统计方式" prop="standardType" align="center" min-width="200"
					:show-overflow-tooltip='true'>
					<template #default="scope">
						{{ formatStandardType(scope.row.standardType) }}
					</template>
				</el-table-column>
				<!-- 达标总步数 -->
				<el-table-column label="达标总步数" prop="totalStandardSteps" align="center" min-width="150"
					:show-overflow-tooltip='true'>
					<template #default="scope">
						{{ scope.row.totalStandardSteps != null && scope.row.totalStandardSteps !== '' ? scope.row.totalStandardSteps : '-' }}
					</template>
				</el-table-column>
				<!-- 是否展示排行榜 -->
				<el-table-column label="是否展示排行榜" prop="isShowRanking" align="center" min-width="150"
					:show-overflow-tooltip='true'>
					<template #default="scope">
						{{ formatIsShowRanking(scope.row.isShowRanking) }}
					</template>
				</el-table-column>
				<!-- 是否定时发送短信 -->
				<el-table-column label="是否定时发送短信" prop="isTimingSendSms" align="center" min-width="150"
					:show-overflow-tooltip='true'>
					<template #default="scope">
						{{ formatIsTimingSendSms(scope.row.isTimingSendSms) }}
					</template>
				</el-table-column>
				<!-- 月初短信发送日期 -->
				<el-table-column label="月初短信发送日期" prop="monthBeginSendDay" align="center" min-width="200"
					:show-overflow-tooltip='true'>
					<template #default="scope">
						{{ scope.row.monthBeginSendDay != null && scope.row.monthBeginSendDay !== '' ? scope.row.monthBeginSendDay : '-' }}
					</template>
				</el-table-column>
				<!-- 月初短信发送时间 -->
				<el-table-column label="月初短信发送时间" prop="monthBeginSendTime" align="center" min-width="200"
					:show-overflow-tooltip='true'>
					<template #default="scope">
						{{ formatSecondsToTime(scope.row.monthBeginSendTime) }}
					</template>
				</el-table-column>
				<!-- 月底短信发送日期 -->
				<el-table-column label="月底短信发送日期" prop="monthEndSendDay" align="center" min-width="200"
					:show-overflow-tooltip='true'>
					<template #default="scope">
						{{ scope.row.monthEndSendDay != null && scope.row.monthEndSendDay !== '' ? scope.row.monthEndSendDay : '-' }}
					</template>
				</el-table-column>
				<!-- 月底短信发送时间 -->
				<el-table-column label="月底短信发送时间" prop="monthEndSendTime" align="center" min-width="200"
					:show-overflow-tooltip='true'>
					<template #default="scope">
						{{ formatSecondsToTime(scope.row.monthEndSendTime) }}
					</template>
				</el-table-column>
				<el-table-column label="操作" align="center" fixed="right" min-width="200">
					<template #default="scope">
						<el-button size="default" @click="copyreader(scope.row.unionId)" class="bulur"><el-icon
								class="cancel">
								<EditPen />
							</el-icon>编辑</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- 表格分页 -->
			<!-- 一页时候隐藏 hide-on-single-page="true" -->
			<el-pagination layout="prev, pager, next,sizes" hide-on-single-page="true" :page-sizes="[6, 12, 18, 24]"
				:current-page="currentPage" :page-size="pagesize" :total="zong" @size-change="handleSizeChange"
				@current-change="handleCurrentChange" />
		</el-card>

	
		<!-- 所属组织弹窗 -->
		<div>
			<el-dialog v-model="visible" title="所属组织" width="500px" top="10vh" custom-class="organization-dialog" :close-on-click-modal="true" destroy-on-close>
				<el-tree :data="texture" :props="defaultProps" accordion @node-click="dendrogram" />
				<template #footer><el-button type="primary" @click="visible = false">确定</el-button></template>
			</el-dialog>
		</div>
	</div>
</template>
<script>
export default {
	name: 'settingsWalk'
}
</script>
<script setup>
import { ref, onMounted, nextTick, onBeforeUnmount } from 'vue'
import { Search,EditPen,Plus } from '@element-plus/icons-vue'
import { useRouter } from 'vue-router'
import { queryWalkPowerUnionList, Zzlist } from '../../utils/api'
import qs from 'qs'

// 路由
const router = useRouter()

// 弹窗提示
const formative = ref(false)
// 时间选择
const value2 = ref('')
// 隐藏下拉框
const selectIt = ref()
const closeIt = () => {
	selectIt.value.blur()
}
// 加载中
const texts = ref('加载中')
// 选择组织搜索框变化
const numerical = () => {
	Hcode.value = ''
}
// 是否达标选择值
const achieve = ref('')
// 获取code
const Hcode = ref('')
// 搜索组织搜索框选择值
const ability = ref('')
// 弹窗树形选择
const dendrogram = (node) => {
	ability.value = node.unionName
	Hcode.value = node.unionCode
}
// 弹窗组织列表树形
const texture = ref([])
const defaultProps = {
	children: 'unionDtoList',
	label: 'unionName',
}
// 搜索组织列表接口
const lang = () => {
	Zzlist().then((res) => {
		texture.value = res.data.data.wholeUnionList
	})
}
// 搜索组织弹窗
const visible = ref(false)
// 顶部搜索
const itemss = ref('')
const search1 = () => {
	formative.value = true
	search()
}
const search = () => {
	let now = new Date()
	let nowYear = now.getFullYear() //当前年
	let nowMonth = now.getMonth() //当前月
	let firstDay = new Date(nowYear, nowMonth, 1).getTime()
	if (value2.value !== '' && value2.value !== null) {
		itemss.value = value2.value.getTime()
	} else {
		itemss.value = firstDay
	}
	let data = {
		limit: branches.value,
		page: currentPage.value,
		name: designation.value,
		username: serial.value,
		unionCode: Hcode.value,
		isStandard: achieve.value,
		startTime: itemss.value / 1000
	}
	JBlist(qs.stringify(data)).then((res) => {
		formative.value = false
		zong.value = res.data.data.page.totalCount
		filterTableData.value = res.data.data.page.list
		if (filterTableData.value.length == 0) {
			texts.value = '暂无数据'
		}
	})
}
// 会员编码
const serial = ref('')
// 会员名称
const designation = ref('')
// 分页
const currentPage = ref(1)
const pagesize = ref(6)
const handleSizeChange = (size) => {
	pagesize.value = size
	branches.value = size
	if (designation.value !== '' || serial.value !== '' || ability.value !== '' || achieve.value !== '' ||
		itemss.value !== '') {
		search()
	} else {
		list()
	}
}
const handleCurrentChange = (size) => {
	currentPage.value = size
	texts.value = '加载中'
	if (designation.value !== '' || serial.value !== '' || ability.value !== '' || achieve.value !== '' ||
		itemss.value !== '') {
		search()
	} else {
		list()
	}
}
// 列表是否达标
const reach = (row, column, cellValue) => {
	if (cellValue == 1) {
		return '是'
	} else if (cellValue === 2) {
		return '否'
	}
}
// 查看跳转
const copyreader = (unionId) => {
	localStorage.setItem('unionId', unionId)
	router.push('/walking/edit')
}
// 列表数据循环
const filterTableData = ref([])
// 动态加载数据
const branches = ref(6)
// 数据总共条数
const zong = ref(null)
// 列表-分页查询会员按天步数数据
const tableRef = ref(null)
const refreshTableLayout = () => {
	nextTick(() => {
		tableRef.value?.doLayout?.()
	})
}

const dataInfo = () => {

	queryWalkPowerUnionList(qs.stringify()).then((res) => {
		if (res.data.code == 0) {
			filterTableData.value = res.data.data.walkPowerUnionList
			if (filterTableData.value.length == 0) {
				texts.value = '暂无数据'
			}
		}
	})
}

// 统计方式格式化
const formatStandardType = (type) => {
	const map = {
		'1': '每日步数达标天数',
		'2': '月总步数',
		'3': '排行榜'
	}
	return map[type] || map[type + ''] || ''
}

// 是否展示排行榜格式化
const formatIsShowRanking = (val) => {
	const map = {
		'1': '展示',
		'2': '不展示'
	}
	return map[val] || map[val + ''] || ''
}

// 秒数转时间格式（如 34200 → 09:30）
const formatSecondsToTime = (seconds) => {
	if (seconds == null || seconds === '' || isNaN(seconds)) return '-'
	const totalSeconds = Number(seconds)
	const hours = Math.floor(totalSeconds / 3600)
	const minutes = Math.floor((totalSeconds % 3600) / 60)
	return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`
}

// 添加跳转
const handleAdd = () => {
	router.push('/walking/add')
}

// 是否定时发送短信格式化
const formatIsTimingSendSms = (val) => {
	const map = {
		'1': '开启',
		'2': '关闭'
	}
	return map[val] || map[val + ''] || ''
}

onMounted(() => {
	dataInfo()
	lang()
	window.addEventListener('resize', refreshTableLayout)
})
onBeforeUnmount(() => {
	window.removeEventListener('resize', refreshTableLayout)
})
</script>
<style lang="scss" scoped>
	::v-deep .chart-card::-webkit-scrollbar {
		display: none
	}

	.chart-card {
		height: calc(100vh - 145px);
		overflow: auto;
	}
	::v-deep input::-webkit-outer-spin-button,
	::v-deep input::-webkit-inner-spin-button {
		-webkit-appearance: none !important;
	}

	::v-deep .el-table__empty-block {
		border-bottom: 1px solid #EBEEF5 !important;
	}

	.el-button+.el-button {
		margin-left: 0px;
	}

	.statistics {
		font-size: 14px;
		color: #909399;
		// margin-bottom: 15px;
	}

	::v-deep .el-table__body {
		margin-top: 0 !important;
		margin-bottom: 0 !important;
	}

	::v-deep .el-table__header {
		margin-top: 0 !important;
		margin-bottom: 0 !important;
	}

	.hunt {
		width: 25%;
		margin-right: 10px;
	}

	.grabble {
		width: 100%;
		margin-top: 20px;
		margin-bottom: 15px;
		display: flex;
		justify-content: space-between;
	}
.grabble1 {
		width: 100%;
		// margin-top: 20px;
		margin-bottom: 15px;
		display: flex;
		justify-content: space-between;
	}
	.el-table__header {
		margin-top: 0;
		margin-bottom: 0;
	}

	.bulur {
		color: #409eff;
		border: none;
		--el-button-bg-color: none;
		--el-button-hover-bg-color: none;
		--el-button-hover-text-color: none;
	}

	.bulur:hover {
		color: #a0cfff;
	}

	// .el-button{
	//   border: none;
	//   --el-button-bg-color:none;
	//   --el-button-hover-bg-color:none;
	//   --el-button-hover-text-color:none;
	// }

	.el-select .el-input__inner {
		width: 183px;
	}

	::v-deep .el-dialog--center .el-dialog__body {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	::v-deep .el-select-dropdown__empty {
		display: none !important;
	}

	.el-select-dropdown__item {
		background-color: #ffffff;
		height: 40px !important;
		overflow: visible;
	}

	.cancel {
		margin-right: 5px;
		font-weight: 400;
	}

	.cancelgu {
		margin-right: 6px;
		font-weight: bold;
	}

	::v-deep .el-table__inner-wrapper::before {
		width: 0;
	}

	::v-deep .el-table .el-table__cell {
		padding-top: 15px;
		padding-bottom: 15px;
	}

	.el-card.is-always-shadow {
		width: 95%;
		padding-left: 20px;
		padding-right: 20px;
		padding-bottom: 20px;
	}

	::v-deep .el-card__body {
		padding: 0;
	}

	.el-pagination {
		margin-top: 10px;
	}

	::v-deep .el-input--small .el-input__inner {
		height: 30px;
		line-height: 30px;
	}

	.tabulation {
		margin-top: 10px;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-bottom: 10px;
	}


</style>
<style>
	/* ::-webkit-scrollbar{display:none} */
	.el-popper {
		z-index: 10000 !important;
	}

	/* .el-scrollbar__thumb {
	display: none !important;
} */
	.el-select-dropdown__item.selected {
		font-weight: 500 !important;
	}
</style>
